/***
 * @file:
 * @author: linkun.he
 * @Date: 2021-05-31 16:29:12
 */
import { ModuleWithProviders, NgModule } from '@angular/core';

import { PermissionDirective } from './permission.directive';

import { PermissionsService } from './permission.service';
import { ScrollService } from './scroll.service';
import { SetProjectInfoService } from './set-project-info.service';
import { SettingsService } from './setting.service';
import { TenantService } from './tenant.service';

import { SafePipe } from './safe.pipe';

// æä»¤
const DIRECTIVE = [PermissionDirective];

const SERVICE = [PermissionsService, ScrollService, SetProjectInfoService, SettingsService, TenantService];

const PIPE = [SafePipe];

// @dynamic
@NgModule({
  imports: [],
  declarations: [...PIPE, ...DIRECTIVE],
  exports: [...PIPE, ...DIRECTIVE],
})
export class DtBrowserModule {
  static forRoot(sharedUserConfig?): ModuleWithProviders {
    return {
      ngModule: DtBrowserModule,
      providers: [{ provide: 'SHARED_USER_CONFIG', useValue: sharedUserConfig }, ...SERVICE],
    } as ModuleWithProviders;
  }
}
